document.addEventListener("DOMContentLoaded", () => {
  const toggleButton = document.querySelector(".js-toggle-button");
  const hiddenContent = document.querySelector(".js-hidden-content");
  const buttonText = toggleButton.querySelector(".button-text");

  toggleButton.addEventListener("click", () => {
    if (hiddenContent.style.maxHeight) {
      // 閉じる動作
      hiddenContent.style.maxHeight = null;
      toggleButton.classList.remove("open");
      buttonText.textContent = "続きを見る";
    } else {
      // 開く動作
      hiddenContent.style.maxHeight = `${hiddenContent.scrollHeight}px`;
      toggleButton.classList.add("open");
      buttonText.textContent = "閉じる";
    }
  });

  // アニメーション終了後に高さを固定解除
  hiddenContent.addEventListener("transitionend", () => {
    if (hiddenContent.style.maxHeight) {
      hiddenContent.style.maxHeight = "none"; // 完全表示時に高さ制限を解除
    }
  });
});

$(function () {
  var topBtn = $('#to-top');
  topBtn.hide();
  /*スクロールが500に達したらボタン表示 */
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });

  $('body').on('touchmove', function () {
    if ($(this).scrollTop() > 500) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });

  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    /*var position = target.offset().top - '25';*/
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});


if (window.matchMedia('(max-width: 1100px)').matches) {

  $(function() {
    $('.hamburger').click(function() {
      $(this).toggleClass('active');

      if ($(this).hasClass('active')) {
        $('.p-header').addClass('active');
        $('.p-header__nav').addClass('active');
      } else {
        $('.p-header').removeClass('active');
        $('.p-header__nav').removeClass('active');
      }
    });
  });

  //メニュー内を閉じておく
  $(function() {
    $('.p-header__nav a[href]').click(function() {
      $('.p-header__nav').removeClass('active');
      $('.hamburger').removeClass('active');
      $('.p-header').removeClass('active');
    });
  });

} //spのみ


//anchor 位置調整
$(function(){
  var headerHeight = $('header').outerHeight(); // ヘッダーについているID、クラス名など、余白を開けたい場合は + 10を追記する。
  var urlHash = location.hash; // ハッシュ値があればページ内スクロール
  if(urlHash) { // 外部リンクからのクリック時
    $('body,html').stop().scrollTop(0); // スクロールを0に戻す
    setTimeout(function(){ // ロード時の処理を待ち、時間差でスクロール実行
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 500); // スクロール速度ミリ秒
    }, 100);
  }
  $('a[href^="#"]').click(function(){ // 通常のクリック時
    var href= $(this).attr("href"); // ページ内リンク先を取得
    var target = $(href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 500); // スクロール速度ミリ秒
    return false; // #付与なし、付与したい場合は、true
  });
});


//floating banner
let $pagetop = $('.js-flowting-banner');
$(window).on('scroll', function () {

  var check = window.pageYOffset; //現在のスクロール地点 
  var docHeight = $(document).height(); //ドキュメントの高さ
  var dispHeight = $(window).height(); //表示領域の高さ        

  //スクロール位置を取得
  if ($(this).scrollTop() < 150) {
    $pagetop.removeClass('isActive');
  } else {
    $pagetop.addClass('isActive');
  }
});
